import * as React from 'react';
// @ts-expect-error
import {DropTarget, ConnectDropTarget} from 'react-dnd';

import type {DragItemLeadCard} from 'nutshell-core/visual-pipeline';

import {dragItemTypes, dropResultTypes} from '../../dnd/drag-item-types';
import type {PipelineColumnDropResult} from '../../dnd/drag-item-types';

import styles from './visual-pipeline-column-drop-target.module.css';

type OwnProps = {
    children?: any;
    stageId: string;
    isDropTarget: boolean;
};

type DndProps = {
    connectDropTarget: ConnectDropTarget;
    isOver: boolean;
    draggedItem?: DragItemLeadCard;
    canDrop: boolean;
    itemType: string;
};

type Props = DndProps & OwnProps;

export class VisualPipelineColumnDropTargetComponent extends React.PureComponent<Props> {
    render() {
        const isBeingHovered =
            this.props.isOver &&
            this.props.draggedItem &&
            this.props.draggedItem.stageId !== this.props.stageId;

        return this.props.connectDropTarget(
            <div className={styles['drop-target']}>
                {isBeingHovered ? (
                    <div className={styles['drop-target-hover-overlay']} />
                ) : undefined}
                {this.props.children}
            </div>
        );
    }
}

const leadCardTarget = {
    // @ts-expect-error
    drop(props): PipelineColumnDropResult {
        return {
            type: dropResultTypes.PIPELINE_COLUMN,
            payload: {
                stageId: props.stageId,
            },
        };
    },
    // @ts-expect-error
    canDrop(props) {
        return props.isDropTarget;
    },
} as const;

// @ts-expect-error
const leadCardConnect = (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
    itemType: monitor.getItemType(),
    draggedItem: monitor.getItem(),
});

export const VisualPipelineColumnDropTarget = DropTarget<OwnProps, Props>(
    dragItemTypes.LEAD_CARD,
    leadCardTarget,
    leadCardConnect
)(VisualPipelineColumnDropTargetComponent);
